import React, { useState } from 'react';
import { useAuth } from '../Context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Container, Card, Form, Button } from 'react-bootstrap';
import { Lock, User } from 'lucide-react';
import Swal from 'sweetalert2';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;

    setIsLoading(true);
    try {
      const result = await login(username, password);
      
      if (result.success) {
        navigate(from, { replace: true });
      } else {
        // Yetki reddi gibi özel mesajları göster; yoksa genel hata metni
        const isAccessDenied = result.message && result.message.includes('yetki');
        Swal.fire({
          icon: isAccessDenied ? 'warning' : 'error',
          title: isAccessDenied ? 'Erişim Yok' : 'Giriş Başarısız',
          text: result.message || 'Girdiğiniz e-posta veya şifre hatalı. Lütfen kontrol edip tekrar deneyin.',
          confirmButtonColor: '#0d6efd',
          confirmButtonText: 'Tamam'
        });
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Giriş Başarısız',
        text: 'Girdiğiniz e-posta veya şifre hatalı. Lütfen kontrol edip tekrar deneyin.',
        confirmButtonColor: '#0d6efd',
        confirmButtonText: 'Tamam'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <Container style={{ maxWidth: '400px' }}>
        <motion.div
           initial={{ opacity: 0, y: -20 }}
           animate={{ opacity: 1, y: 0 }}
           transition={{ duration: 0.5 }}
        >
          <div className="text-center mb-4">
             <div className="bg-primary d-inline-flex align-items-center justify-content-center rounded-circle text-white mb-3 shadow-sm" style={{width: 64, height: 64}}>
                <Lock size={32} />
             </div>
             <h2 className="fw-bold text-dark font-monospace ls-2">UNIVERSAL ARENA</h2>
             <p className="text-muted">Yönetici Girişi</p>
          </div>

          <Card className="border-0 shadow-lg overflow-hidden custom-card">
            <Card.Body className="p-4">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold text-secondary">E-POSTA</Form.Label>
                  <div className="position-relative">
                     <Form.Control 
                        type="email" 
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="ps-5 shadow-none"
                        placeholder="ornek@email.com"
                        autoFocus
                        required
                        disabled={isLoading}
                     />
                     <User size={18} className="text-muted position-absolute" style={{top: 11, left: 15}} />
                  </div>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="small fw-bold text-secondary">ŞİFRE</Form.Label>
                  <div className="position-relative">
                     <Form.Control 
                        type="password" 
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="ps-5 shadow-none"
                        placeholder="••••••"
                        required
                        disabled={isLoading}
                     />
                     <Lock size={18} className="text-muted position-absolute" style={{top: 11, left: 15}} />
                  </div>
                </Form.Group>

                <Button 
                   type="submit" 
                   variant="primary" 
                   className="w-100 py-2 fw-bold shadow-sm"
                   disabled={isLoading}
                >
                   {isLoading ? 'GİRİŞ YAPILIYOR...' : 'GİRİŞ YAP'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
          
          <p className="text-center text-muted small mt-4 opacity-75">
             Lütfen sisteme kayıtlı admin e-posta adresiniz ile giriş yapınız.
          </p>
        </motion.div>
      </Container>
    </div>
  );
};

export default Login;
